import React from 'react';
import styles from './DiscardModal.module.css';
import { useTranslation } from 'react-i18next';

const DiscardModal = ({ onClose, onDiscard }) => {
  const { t } = useTranslation();
  
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>{t("quiz.discardQuizTitle")}</h3>
          <button className={styles.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>
        <p className={styles.message}>{t("quiz.discardWarningText")}</p>
        <div className={styles.actions}>
          <button className={styles.discardButton} onClick={onDiscard}>
            {t("quiz.discardQuizBtnText")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscardModal;
